/**
 * Amplify-style auth config (maintained manually; not overwritten by Amplify CLI).
 *
 * Choose environment with:
 *   NEXT_PUBLIC_AWS_ENV=dev   (default when unset)
 *   NEXT_PUBLIC_AWS_ENV=prod
 *
 * Set in `.env.local`, Vercel/hosting env, or CI.
 */

const awsExportsDev = {
	aws_project_region: "us-east-1",
	aws_cognito_region: "us-east-1",
	aws_user_pools_id: "us-east-1_E0gMVDPav",
	aws_user_pools_web_client_id: "7c8hvnogpi5djg3no7ittr37do",
	oauth: {},
	aws_cognito_username_attributes: ["EMAIL"],
	aws_cognito_social_providers: [],
	aws_cognito_signup_attributes: ["EMAIL"],
	aws_cognito_mfa_configuration: "ON",
	aws_cognito_mfa_types: ["SMS"],
	aws_cognito_password_protection_settings: {
		passwordPolicyMinLength: "6",
		passwordPolicyCharacters: [],
	},
	aws_cognito_verification_mechanisms: ["EMAIL"],
};

/**
 * Production Cognito — set pool/client IDs here and/or via:
 *   NEXT_PUBLIC_COGNITO_USER_POOL_ID_PROD
 *   NEXT_PUBLIC_COGNITO_USER_POOL_CLIENT_ID_PROD
 *   NEXT_PUBLIC_AWS_REGION (optional; defaults below)
 */
const awsExportsProd = {
	aws_project_region:
		(typeof process !== "undefined" &&
			process.env?.NEXT_PUBLIC_AWS_REGION) ||
		"us-east-1",
	aws_cognito_region:
		(typeof process !== "undefined" &&
			process.env?.NEXT_PUBLIC_AWS_REGION) ||
		"us-east-1",
	aws_user_pools_id:
		(typeof process !== "undefined" &&
			process.env?.NEXT_PUBLIC_COGNITO_USER_POOL_ID_PROD) ||
		"us-east-1_QuXTkinqM",
	aws_user_pools_web_client_id:
		(typeof process !== "undefined" &&
			process.env?.NEXT_PUBLIC_COGNITO_USER_POOL_CLIENT_ID_PROD) ||
		"6qfavumcq8cqgmuk2gbnn4kjrv",
	oauth: {},
	aws_cognito_username_attributes: ["EMAIL"],
	aws_cognito_social_providers: [],
	aws_cognito_signup_attributes: ["EMAIL"],
	aws_cognito_mfa_configuration: "ON",
	aws_cognito_mfa_types: ["SMS"],
	aws_cognito_password_protection_settings: {
		passwordPolicyMinLength: "6",
		passwordPolicyCharacters: [],
	},
	aws_cognito_verification_mechanisms: ["EMAIL"],
};

const awsEnv =
	(typeof process !== "undefined" && process.env?.NEXT_PUBLIC_AWS_ENV) ||
	"prod";

const configs = {
	dev: awsExportsDev,
	prod: awsExportsProd,
};

const awsauth = configs[awsEnv] ?? configs.dev;

export default awsauth;
